function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import FroalaEditor from 'react-froala-wysiwyg';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/cryptojs.min.js';
import 'froala-editor/js/plugins/draggable.min.js';
import 'froala-editor/js/plugins/edit_in_popup.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/entities.min.js';
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins/files_manager.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/forms.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/help.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/image_manager.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/line_breaker.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/markdown.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/print.min.js';
// import 'froala-editor/js/plugins/quick_insert.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/save.min.js';
import 'froala-editor/js/plugins/special_characters.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/track_changes.min.js';
import 'froala-editor/js/plugins/trim_video.min.js';
import 'froala-editor/js/plugins/url.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';
import 'froala-editor/css/plugins/char_counter.min.css';
import 'froala-editor/css/plugins/code_view.min.css';
import 'froala-editor/css/plugins/colors.min.css';
import 'froala-editor/css/plugins/draggable.min.css';
import 'froala-editor/css/plugins/emoticons.min.css';
import 'froala-editor/css/plugins/file.min.css';
import 'froala-editor/css/plugins/files_manager.min.css';
import 'froala-editor/css/plugins/fullscreen.min.css';
import 'froala-editor/css/plugins/help.min.css';
import 'froala-editor/css/plugins/image.min.css';
import 'froala-editor/css/plugins/image_manager.min.css';
import 'froala-editor/css/plugins/line_breaker.min.css';
import 'froala-editor/css/plugins/markdown.min.css';
import 'froala-editor/css/plugins/quick_insert.min.css';
import 'froala-editor/css/plugins/special_characters.min.css';
import 'froala-editor/css/plugins/table.min.css';
import 'froala-editor/css/plugins/trim_video.min.css';
import 'froala-editor/css/plugins/video.min.css';
import 'font-awesome/css/font-awesome.css';
import 'froala-editor/css/froala_editor.pkgd.css';
import './Froala.scss';
import ThemeContext from '../../ThemeContext';
import cs from 'classnames';
import en from './locales/Froala.en.json';
import compose from '../../utils/compose';
import { default as withInputContainer } from '../withInputContainer/withInputContainer';
import { injectIntl } from 'react-intl';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import getLabelId from '../getLabelId';
import { TextInput } from '../TextInput/TextInput';
import MetadataContext from '../../MetadataContext';
var MSG_PREFIX = '@dm/components.froala';
var messages = normalizeLocaleData(en, MSG_PREFIX);
var DEFAULT_OPTIONS = {
  immediateReactModelUpdate: true,
  attribution: false,
  pasteDeniedAttrs: ['class', 'contenteditable', 'id', 'style'],
  wordDeniedAttrs: ['class', 'contenteditable', 'id', 'style']
};
var getOptions = function getOptions(custom) {
  return _objectSpread({}, DEFAULT_OPTIONS, custom);
};
export var Froala = function Froala(props) {
  var auto = props.auto,
    descriptionId = props.descriptionId,
    disabled = props.disabled,
    iconIds = props.iconIds,
    errorId = props.errorId,
    errorMsg = props.errorMsg,
    id = props.id,
    intl = props.intl,
    label = props.label,
    maxLength = props.maxLength,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onInfoMessage = props.onInfoMessage,
    readonly = props.readonly,
    _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size,
    style = props.style,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    width = props.width,
    _props$events = props.events,
    events = _props$events === void 0 ? {} : _props$events,
    _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config;
  var _useContext = useContext(MetadataContext),
    froalaLicense = _useContext.froalaLicense;
  var containerRef = useRef();
  var onBlurRef = useRef();
  var onFocusRef = useRef();
  onBlurRef.current = onBlur;
  onFocusRef.current = onFocus;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasFocus = _useState2[0],
    setHasFocus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  useEffect(function () {
    if (loaded && containerRef.current) {
      var froala = containerRef.current.querySelector('.fr-view');
      if (froala && !froala.id) {
        froala.id = id;
        froala.setAttribute('aria-describedby', "".concat(iconIds, " ").concat(descriptionId, " ").concat(errorId));
        froala.setAttribute('aria-errormessage', errorId);
        froala.setAttribute('aria-label', label);
        froala.setAttribute('aria-labelledby', getLabelId(id));
        froala.setAttribute('role', 'textbox');
      }
    }
  }, [descriptionId, errorId, iconIds, id, label, loaded]);
  var handleCharacterLimitExceeded = useCallback(function () {
    if (onInfoMessage) {
      var limit = config.charCounterMax || maxLength;
      var current = this.charCounter.count();
      var message = !limit || limit - current < 100 ? 'exceeded' : 'paste';
      var messageId = '.messages.character-limit-' + message;
      onInfoMessage(intl.formatMessage({
        id: MSG_PREFIX + messageId
      }, {
        limit: limit
      }));
    }
  }, [config, intl, onInfoMessage, maxLength]);
  var handleChange = useCallback(function (newValue) {
    // Froala 4 is firing extra change messages causing dirty form handling to trigger
    //   seems like even cursoring around fires a change
    // PRO-12291 & PRO-12288 Adding DSA entries above or below causes Froala to trigger
    //	a "<div></div>" change as the component is remounted. Ideally, this would be
    //	fixed by adding keys to the DSA rows so they "match-up" better, but this is
    //	not easy with the react-jsonschema-form library.
    if (value !== newValue && newValue !== '<div></div>') {
      onChange(newValue);
    }
  }, [value, onChange]);
  var onChangeRef = useRef();
  onChangeRef.current = handleChange;
  var FroalaComponent = disabled ? FroalaEditorView : FroalaEditor;
  var theme = useContext(ThemeContext);
  if (theme === 'ripple' && disabled) {
    return /*#__PURE__*/React.createElement(TextInput, Object.assign({}, props, {
      value: /*#__PURE__*/React.createElement("div", {
        className: "_dm-input--wysiwyg--disabled",
        dangerouslySetInnerHTML: {
          __html: props.value
        }
      })
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cs("_dm-input _dm-input--".concat(size), "_dm-input--wysiwyg _dm-input--wysiwyg--".concat(size), "_dm-input--wysiwyg--".concat(theme, " _dm-input--wysiwyg--").concat(theme, "--").concat(size), "auto-wysiwyg-input", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, auto, auto), '_dm-input--wysiwyg--focus', hasFocus), '_dm-input--wysiwyg--error', !!errorMsg), '_dm-input--wysiwyg--disabled', disabled), '_dm-input--wysiwyg--charCounterEnabled', config && !!config.charCounterCount), '_dm-input--wysiwyg--charCounterDisabled', !(config && !!config.charCounterCount))),
    ref: containerRef,
    style: style
  }, /*#__PURE__*/React.createElement(FroalaComponent
  // froala stuff
  , {
    config: getOptions(_objectSpread({
      key: froalaLicense,
      width: width,
      charCounterMax: maxLength || -1,
      pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'embedly', 'emoticons', 'entities', 'file', 'fontAwesome', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'imageTUI', 'imageManager', 'inlineStyle', 'inlineClass', 'lineBreaker', 'lineHeight', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'quote', 'save', 'table', 'video', 'wordPaste']
    }, config, {
      charCounterCount: true,
      // disabled w/ css otherwise charCounterMax won't be enforced
      // @todo handle for events in the config...
      events: _objectSpread({}, events, {
        initialized: function initialized() {
          // Prevent dropping files onto editor
          this.events.on('drop', function (dropEvent) {
            dropEvent.preventDefault();
            dropEvent.stopPropagation();
            dropEvent.stopImmediatePropagation();
            return false;
          }, true);
          var orgEvent = events['initialized'];
          if (readonly) {
            this.edit.off();
            this.toolbar.disable();
          }
          setLoaded(true);
          orgEvent && orgEvent.call(this);
        },
        blur: function blur() {
          var orgEvent = events['blur'];
          onBlurRef.current && onBlurRef.current.call(this);
          orgEvent && orgEvent.call(this);
          setHasFocus(false);
        },
        focus: function focus() {
          var orgEvent = events['focus'];
          onFocusRef.current && onFocusRef.current.call(this);
          orgEvent && orgEvent.call(this);
          setHasFocus(true);
        },
        'charCounter.exceeded': handleCharacterLimitExceeded,
        'paste.after': function pasteAfter() {
          var _this = this;
          // Fix froala adding `id="isPasted"` to pasted content, potentially causing accessibility issues
          // See: https://github.com/froala/wysiwyg-editor/issues/4328
          this.selection.save();
          var t = document.createElement('template');
          t.innerHTML = this.html.get(true);
          var offender = t.content.querySelector('#isPasted');
          if (offender) {
            offender.removeAttribute('id');
            this.html.set(t.innerHTML);
            this.selection.restore();
          }

          // Fix for Froala not sending a change event until after the command/control key is released.
          //  This can lose data when using the mouse to "right-click" paste.
          setTimeout(function () {
            return onChangeRef.current(_this.html.get(true));
          }, 1);
        }
      })
    })),
    model: value,
    onModelChange: handleChange
    // normal stuff
    ,
    id: id
  }));
};
var enhanced = compose(withAdditionalIntl(messages), injectIntl)(Froala);
export default withInputContainer({
  type: 'wysiwyg'
})(enhanced);